function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.53 1h6.94c.411 0 .665.428.454.764L9.227 6.046h2.242c.412 0 .667.428.455.764l-5.066 8.042c-.178.283-.636.128-.587-.199l.837-5.58H5.457a.522.522 0 01-.526-.442l-.927-7.064C3.964 1.266 4.211 1 4.53 1z",
  fill: "currentColor"
})));